import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { seoDataObj } from "../data/components/seo";
import withLocation from "../lib/withLocation";
import "./main-layout.scss";
import { Seo } from "../components/seo";
import Lenis from "@studio-freight/lenis";
import ReactContext from "../context/reactContext";

const LandingPageLayout = ({
  children,
  location,
  title = "",
  description = "",
  meta = [],
}) => {
  const { pathname } = location;
  const [modalComponent, setModalComponent] = useState(null);
  const [section, setSection] = useState("plaque");
  const [menuActive, setMenuActive] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Disable Lenis on projects page to allow container scrolling
    if (pathname === "/projects" || pathname === "/projects/") {
      return;
    }

    const lenis = new Lenis({
      lerp: 0.1,
      duration: 1.3,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      smoothWheel: true,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const rafId = requestAnimationFrame(raf);
    return () => {
      lenis.off("scroll");
      cancelAnimationFrame(rafId);
    };
  }, [pathname]);

  useEffect(() => {
    // Check initial dark mode state
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains("dark"));
    };

    checkDarkMode();

    // Watch for changes to dark mode
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  const seoData = seoDataObj[pathname] ||
    seoDataObj[pathname.substr(0, pathname.length - 1)] || {
      title,
      description,
      meta,
    };

  return (
    <ReactContext.Provider
      value={{
        modalComponent,
        setModalComponent,
        section,
        setSection,
        menuActive,
        setMenuActive,
        isDarkMode,
      }}
    >
      <div className="jb-site">
        {seoData && <Seo {...seoData} />}
        <div className="jb-content">{children}</div>
      </div>
      {modalComponent}
    </ReactContext.Provider>
  );
};

LandingPageLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
};

export default withLocation(LandingPageLayout);
